import React from 'react';
import * as mobxReact from 'mobx-react';
import { injectIntl, IntlShape } from 'react-intl';
import { CustomPageConfigurationType } from '../../../../../../api/custom-pages.dao';
import Text from '../../../../../global/text/text';
import { OEToggle } from '../../../../../global/oe-toggle/oe-toggle';

interface IProps {
    page: CustomPageConfigurationType;
    intl: IntlShape;
    onChange: () => void;
}

export const CustomFieldHidden = injectIntl(mobxReact.observer((props: IProps): JSX.Element => {
    const { page, onChange } = props;
    const { label, enabled } = page;

    return (
        <div className='custom-field__hidden'>
            <OEToggle
                isSelected={enabled}
                onClick={onChange}
            />
            <span className='website-custom__disabled'>
                <Text message={`${label} is Disabled`}/>
            </span>
        </div>
    );
}));